var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),(_vm.customValueFormatter)?_c('span',{class:_vm.valueClass,domProps:{"innerHTML":_vm._s(_vm.customFormatter(_vm.data))}}):_c('span',{class:_vm.valueClass},[_vm._v(_vm._s(_vm.defaultFormatter(_vm.data)))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }